import { render, staticRenderFns } from "./ClientComments.vue?vue&type=template&id=5fff82c4"
import script from "./ClientComments.vue?vue&type=script&lang=js"
export * from "./ClientComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports